import {
  LOADING_ARRAY,
  LIST_UNIT_ALERTS_REQUEST,
  LIST_UNIT_ALERTS_RESPONSE,
  LOGOUT_RESPONSE,
} from '../constants'

// unitId -> [alerts]
const initialState = {}

export default function update(state = initialState, action) {
  switch (action.type) {
    case LIST_UNIT_ALERTS_REQUEST:
      return {
        ...state,
        [action.unitId]: state[action.unitId] || LOADING_ARRAY,
      }

    case LIST_UNIT_ALERTS_RESPONSE: {
      return {
        ...state,
        [action.unitId]: (action.alerts || []).map((a) => a.id),

      }
    }
    case LOGOUT_RESPONSE:
      return initialState
    default:
      return state
  }
}
